<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="pro?.homekeeper?.name + ' ' + ('Settings' | translate)"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (windowService.isDesktopRes) {
    <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper>


    <tidy-card>
      <tidy-card-button (action)="goToJobRequestWorkflows()" class="arrow-to-top">
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Auto Assign'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'You can auto assign this pro to any job opportunity instead of asking them to accept. Turn on Auto Assign in the pro search agent page'" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card>
      <tidy-card-button (action)="goToProSettings()" class="arrow-to-top">
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Auto Pay Invoices'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Set up auto pay limits for each service type and pro.'" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card>
      <tidy-row>
        <tidy-text
          [header]="'Job Limit'" />
      </tidy-row>
      <form [formGroup]="maxJobsForm" novalidate action="#">
        <tidy-row  style="margin-top: -10px">
          <tidy-checkbox
            [items]="[{value: true, viewValue: 'Limit Max Jobs Per Day'}]"
            formControlName="limitMaxJobs"
            [form]="maxJobsForm.controls.limitMaxJobs"
            (checkedChange)="limitMaxJobs()" />
        </tidy-row>
        @if (maxJobsForm.controls.limitMaxJobs.value) {
          <tidy-row>
            <tidy-input
              formControlName="maxJobs"
              [form]="maxJobsForm.controls.maxJobs"
              [submitted]="submitted"
              [inputMode]="'numeric'"
              [type]="'number'"
              [icon]="'assets/svg/create.svg'"
              label="Max Jobs Per Day" />
          </tidy-row>
        }
      </form>
    </tidy-card>


  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
